var instance;
class ServerConnectorService {
    constructor($rootScope, $websocket, VALIDATION_MESSAGES, COMMON_SERVER_SUCCESS_RESPONSES, COMMON_SERVER_ERROR_RESPONSES) {
      this.$rootScope = $rootScope;
      this.websocketService = $websocket;
      this.validationMessages = VALIDATION_MESSAGES;
      this.commonServerSuccessResponses = COMMON_SERVER_SUCCESS_RESPONSES;
      this.commonServerErrorResponses  = COMMON_SERVER_ERROR_RESPONSES;
      instance = this;
      this.send = this.send.bind(this);
      this.validateCommonErrors = this.validateCommonErrors.bind(this);
      this.readFormFieldsError = this.readFormFieldsError.bind(this);
    }
    
    /**
     * opens new websocket connection
     */
    connect(){
        console.log('websocket connect');
        return this.websocketService(process.env.WEBSOCKET_URL);
    }

    /**
     * sends message and notifies about response with #onMessage
     * 
     * @param {json} message - message to send
     * @param {websocket} websocket - websocket instance
     * @param {deferred} deferred
     * @param {function} onMessage - success response callback
     * @param {function} onError - error response callback
     */
    send(message, websocket, deferred, onMessage, onError){
      if(!websocket){
        console.error('send() websocket is null');
        return;
      }

      var token = this.generateRequestToken();
      message.request_token = token;

      this.$rootScope.$broadcast('server-sendingRequestStart');
      websocket.onMessage(function(event) {
        var data = angular.fromJson(event.data);
        // console.log('websocket message', data);
        if(message.action_name != data.action_name || data.request_token != token){
          // response from another request with another action
          return;
        }

        var validationResult = instance.validateCommonErrors(message, data, deferred, onError);
        instance.$rootScope.$broadcast('server-sendingRequestEnd');
        if(angular.isFunction(onMessage) && instance.isValidationResultOk(validationResult)) {
          onMessage(data);
          instance.$rootScope.$broadcast('server-connectionOk');
        }else if(instance.isValidationResultOk(validationResult)){
          deferred.resolve(data);
        }
      });
      
      websocket.onError(function(event) {
        console.error('websocket connection error', event);
        instance.$rootScope.$broadcast('server-sendingRequestEnd');
        deferred.reject('ERROR.SERVER_CONNECTION_ERROR');
      });
      websocket.send(message)
    }

    generateRequestToken() {
	    var length = 15;
      var stringArray = ['0','1','2','3','4','5','6','7','8','9','a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t','u','v','w','x','y','z','A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z'];
   
      var token = "";
      for (var i = 1; i < length; i++) { 
        var rndNum = Math.ceil(Math.random() * stringArray.length) - 1;
        token = token + stringArray[rndNum];
      };

      return token;
    }

    /**
     * 
     * @param {json} request - request message 
     * @param {json} response - response json  
     * @param {deferred} deferred 
     * @param {function} onError - error response callback 
     */
    validateCommonErrors(request, response, deferred, onError){

      var errorResult = {
        status : this.validationMessages.error,
      };

      if(response.status == this.commonServerSuccessResponses.ok || response.status == this.commonServerSuccessResponses.objectsNotFound) {
        return {
          status : this.validationMessages.ok
        };
      } else if(response.status == this.commonServerErrorResponses.parameterParseError){
        this.readFormFieldsError(response, deferred, onError);
        return errorResult;
      } else {
        this.reject([response.status], onError, deferred);
        return errorResult;
      }
    }

    readFormFieldsError(response, deferred, onError) {
      console.log('reading form errrors', response);

      let errors = []
      // must iterate json to chack validation errors
      Object.keys(response).forEach(function(key) {
        if(instance.isNotFormFieldJsonKey(key)) {
          return;
        };
        errors.push(response[key]);
      })

      this.reject(errors, onError, deferred);
    }

    isNotFormFieldJsonKey(key) {
      return key === 'action_name' || key === 'request_token' || key === 'source' || key === 'status';
    }

    /**
     * 
     * @param {string} errors 
     * @param {function} onError - error response callback   
     * @param {*} deferred 
     */
    reject(errors, onError, deferred){
      this.$rootScope.$broadcast('server-connectionError', {errors : errors});
      if(angular.isFunction(onError)){
        onError(errors)
      }else {
        deferred.reject(errors);
      }
    }

    isValidationResultOk(result) {
      return result.status != this.validationMessages.invalidAction && result.status == this.validationMessages.ok
    }

    static factory($rootScope, $websocket, VALIDATION_MESSAGES, COMMON_SERVER_SUCCESS_RESPONSES, COMMON_SERVER_ERROR_RESPONSES){
        return new ServerConnectorService($rootScope, $websocket, VALIDATION_MESSAGES, COMMON_SERVER_SUCCESS_RESPONSES, COMMON_SERVER_ERROR_RESPONSES);
    }
    
}

ServerConnectorService.factory.$inject = ['$rootScope', '$websocket', 'VALIDATION_MESSAGES', 'COMMON_SERVER_SUCCESS_RESPONSES', 'COMMON_SERVER_ERROR_RESPONSES'];

export default ServerConnectorService = ServerConnectorService.factory


// WEBPACK FOOTER //
// ./src/service/server-connector/server-connector.service.js